
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    modelValue: { type: [String, Number], required: false },
    id: { type: String, required: true },
    type: { type: String, required: false, default: 'text' },
    label: { type: String, required: false },
    placeholder: { type: String, required: false, default: null },
    disabled: { type: Boolean, default: false }

  }
})
